export default __webpack_public_path__ + "static/lozenge-anatomy-light-cfb974c43b1f41ca3342f36fb9734e77dd5abc75c01a51d24f6f3711ebab9f03.png";